// Shared by the Floor Deck Utilization card and the Utilities Management
// settings, so both group machines under exactly the same category names.

export function getMachineCategoryName(machine) {
    return String(machine.description || machine.categoryDescription || machine.category || 'Uncategorized');
}

// Returns [{ name, machines }] in the order categories first appear.
export function groupMachinesByCategory(machines) {
    const groups = new Map();
    (machines || []).forEach((machine) => {
        const name = getMachineCategoryName(machine);
        if (!groups.has(name)) groups.set(name, { name, machines: [] });
        groups.get(name).machines.push(machine);
    });
    return Array.from(groups.values());
}

// An empty selection means every category is shown.
export function filterMachinesByCategories(machines, categories) {
    const list = machines || [];
    if (!categories || categories.length === 0) return list;
    const selected = new Set(categories);
    return list.filter((machine) => selected.has(getMachineCategoryName(machine)));
}

// The machines the Utilization card counts: those in the chosen categories,
// minus the machines left out by name. Machines not listed are counted.
export function filterUtilizationMachines(machines, { categories, excludedMachines } = {}) {
    const inCategories = filterMachinesByCategories(machines, categories);
    if (!excludedMachines || excludedMachines.length === 0) return inCategories;
    const excluded = new Set(excludedMachines);
    return inCategories.filter((machine) => !excluded.has(machine.machine));
}
